import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "reusable-set",
  templateUrl: "./reusable-set.component.html",
  styleUrls: ["./reusable-set.component.scss"],
})
export class ReusableSetComponent implements OnInit {
  @Input() public options: any;
  @Output() public dataChanged = new EventEmitter();

  public ngOnInit() {
    this.setFieldsReusable(this.options);
  }

  public setFieldsReusable(options) {
    if (options.components) {
      options.components.forEach((component) => {
        component.reusable = !!(options.reusable);
      });
    }
    this.dataChanged.emit(event);
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
